export enum TaskActionTypes {
    FILE_DOWNLOAD = 'file-download',
    AUTOCOMPLETE = 'autocomplete',
}

type TaskWithExtensions = { extensions?: { [key: string]: any } };

const clientAutoExecutableActions: TaskActionTypes[] = [
    TaskActionTypes.FILE_DOWNLOAD,
    TaskActionTypes.AUTOCOMPLETE,
];

export const getTaskAction = (task?: TaskWithExtensions) =>
    task?.extensions?.action as TaskActionTypes | undefined;

export const isClientAutoExecutableTask = (task?: TaskWithExtensions) => {
    const action = getTaskAction(task);

    return Boolean(action && clientAutoExecutableActions.includes(action));
};
